/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CPurchaseStatus {
    WAITING = 'Waiting',
    CONFIRMED = 'Confirmed',
}
